import React, { Component } from 'react'
import { defineMessages, FormattedMessage, FormattedNumber, injectIntl } from 'react-intl'
import { UNIT_OF_MEASURE } from "../../state/product/Types"

class LabelAmountPerUnitOfMeasure extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            amount: this.props.value || '',
            currency: this.props.currency || '',
            unit: this.props.unit || UNIT_OF_MEASURE.PIECE,
        }
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            unit: nextProps.unit || UNIT_OF_MEASURE.PIECE,
            amount: nextProps.value || '',
            currency: nextProps.currency || ''
        })
    }

    componentDidMount() {
    }

    renderAmount() {
        return <FormattedNumber
            style="currency"
            currency={this.state.currency}
            value={this.state.amount}
        />
    }

    render() {
        const messages = defineMessages({
            "piece_singular_label": {
                id: 'common.unit_of_measure.label.per_unit.piece_singular_label',
                defaultMessage: 'piece',
            },
            "year_singular_label": {
                id: 'common.unit_of_measure.label.per_unit.year_singular_label',
                defaultMessage: 'year',
            },
            "month_singular_label": {
                id: 'common.unit_of_measure.label.per_unit.month_singular_label',
                defaultMessage: 'month',
            },
            "yard_singular_label": {
                id: 'common.unit_of_measure.label.per_unit.yard_singular_label',
                defaultMessage: 'yd',
            },
            "travel_singular_label": {
                id: 'common.unit_of_measure.label.per_unit.travel_singular_label',
                defaultMessage: 'travel',
            },
            "participant_singular_label": {
                id: 'common.unit_of_measure.label.per_unit.participant_singular_label',
                defaultMessage: 'participant',
            },
            "user_singular_label": {
                id: 'common.unit_of_measure.label.per_unit.user_singular_label',
                defaultMessage: 'user',
            },
            "day_singular_label": {
                id: 'common.unit_of_measure.label.per_unit.day_singular_label',
                defaultMessage: 'day',
            },
            "quarter_singular_label": {
                id: 'common.unit_of_measure.label.per_unit.quarter_singular_label',
                defaultMessage: 'qtr',
            },
            "gigabyte_singular_label": {
                id: 'common.unit_of_measure.label.per_unit.gigabyte_singular_label',
                defaultMessage: 'GB',
            },
            "megabyte_singular_label": {
                id: 'common.unit_of_measure.label.per_unit.megabyte_singular_label',
                defaultMessage: 'MB',
            },
            "asset_singular_label": {
                id: 'common.unit_of_measure.label.per_unit.asset_singular_label',
                defaultMessage: 'asset',
            },
            "episode_singular_label": {
                id: 'common.unit_of_measure.label.per_unit.episode_singular_label',
                defaultMessage: 'episode',
            },
            "talent_singular_label": {
                id: 'common.unit_of_measure.label.per_unit.talent_singular_label',
                defaultMessage: 'talent',
            },
            "square_foot_singular_label": {
                id: 'common.unit_of_measure.label.per_unit.square_foot_singular_label',
                defaultMessage: 'ft²',
            }
        })

        let unit = ''
        switch (this.state.unit) {
            case UNIT_OF_MEASURE.PIECE:
                unit = this.props.intl.formatMessage(messages['piece_singular_label'])
                break
            case UNIT_OF_MEASURE.YEAR:
                unit = this.props.intl.formatMessage(messages['year_singular_label'])
                break
            case UNIT_OF_MEASURE.MONTH:
                unit = this.props.intl.formatMessage(messages['month_singular_label'])
                break
            case UNIT_OF_MEASURE.DAY:
                unit = this.props.intl.formatMessage(messages['day_singular_label'])
                break
            case UNIT_OF_MEASURE.INCH:
                unit = '"'
                break
            case UNIT_OF_MEASURE.FOOT:
                unit = "'"
                break
            case UNIT_OF_MEASURE.YARD:
                unit = this.props.intl.formatMessage(messages['yard_singular_label'])
                break
            case UNIT_OF_MEASURE.QUARTER:
                unit = this.props.intl.formatMessage(messages['quarter_singular_label'])
                break
            case UNIT_OF_MEASURE.MILE:
                unit = "mi"
                break
            case UNIT_OF_MEASURE.PAGE:
                unit = "p"
                break
            case UNIT_OF_MEASURE.CENTIMETER:
                unit = "cm"
                break
            case UNIT_OF_MEASURE.METER:
                unit = "m"
                break
            case UNIT_OF_MEASURE.KILOMETER:
                unit = "km"
                break
            case UNIT_OF_MEASURE.SQUARE_METER:
                unit = "m²"
                break
            case UNIT_OF_MEASURE.CUBIC_METER:
                unit = "m3"
                break
            case UNIT_OF_MEASURE.LITER:
                unit = "l"
                break
            case UNIT_OF_MEASURE.MILLILITER:
                unit = "ml"
                break
            case UNIT_OF_MEASURE.GRAM:
                unit = "g"
                break
            case UNIT_OF_MEASURE.KILOGRAM:
                unit = "kg"
            case UNIT_OF_MEASURE.TON:
                unit = "t"
                break
            case UNIT_OF_MEASURE.OUNCE:
                unit = "oz"
                break
            case UNIT_OF_MEASURE.GALLON:
                unit = "gal"
                break
            case UNIT_OF_MEASURE.POUND:
                unit = "lb"
                break
            case UNIT_OF_MEASURE.HOUR:
                unit = "h"
                break
            case UNIT_OF_MEASURE.HOURS_MINUTE:
                unit = "h"
                break
            case UNIT_OF_MEASURE.MINUTE:
                unit = "min"
                break
            case UNIT_OF_MEASURE.PERSON:
                unit = "pers"
                break
            case UNIT_OF_MEASURE.TRAVEL:
                unit = this.props.intl.formatMessage(messages['travel_singular_label'])
                break
            case UNIT_OF_MEASURE.PARTICIPANT:
                unit = this.props.intl.formatMessage(messages['participant_singular_label'])
                break
            case UNIT_OF_MEASURE.USER:
                unit = this.props.intl.formatMessage(messages['user_singular_label'])
                break
            case UNIT_OF_MEASURE.GIGABYTE:
                unit = this.props.intl.formatMessage(messages['gigabyte_singular_label'])
                break
            case UNIT_OF_MEASURE.MEGABYTE:
                unit = this.props.intl.formatMessage(messages['megabyte_singular_label'])
                break
            case UNIT_OF_MEASURE.ASSET:
                unit = this.props.intl.formatMessage(messages['asset_singular_label'])
                break
            case UNIT_OF_MEASURE.EPISODE:
                unit = this.props.intl.formatMessage(messages['episode_singular_label'])
                break
            case UNIT_OF_MEASURE.TALENT:
                unit = this.props.intl.formatMessage(messages['talent_singular_label'])
                break
            case UNIT_OF_MEASURE.SQUARE_FOOT:
                unit = this.props.intl.formatMessage(messages['square_foot_singular_label'])
                break
        }

        if (this.props.shortFormat) {
            return <FormattedMessage
                id="common.unit_of_measure.label.per_unit.piece_label_short"
                defaultMessage="{amount}"
                values={{
                    amount: this.renderAmount(),
                }}
            />
        }

        return <FormattedMessage
            id="common.unit_of_measure.label.per_unit.piece_label"
            defaultMessage="{amount} per {unit}"
            values={{
                amount: this.renderAmount(),
                unit: unit
            }}
        />
    }

}

export default injectIntl(LabelAmountPerUnitOfMeasure)





// WEBPACK FOOTER //
// ./src/common/unit-of-measure/perunit.component.jsx